module.exports = [{"name":"Цель 1"},{"name":"Цель 2"}]


//////////////////
// WEBPACK FOOTER
// ./temp/components/tracking/.variant/base/goalsConfigs/ar/ru/google.yaml
// module id = 143
// module chunks = 2